/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_IsoCalculationValues_CreateUpdateIsoCalculationValuesDto } from '../models/Wealthlane_AwardService_Dtos_IsoCalculationValues_CreateUpdateIsoCalculationValuesDto';
import type { Wealthlane_AwardService_Dtos_IsoCalculationValues_IsoCalculationValuesDto } from '../models/Wealthlane_AwardService_Dtos_IsoCalculationValues_IsoCalculationValuesDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class IsoCalculationValuesService {

    /**
     * @returns Wealthlane_AwardService_Dtos_IsoCalculationValues_IsoCalculationValuesDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppIsoCalculationValuesIsoCalculationValues(): CancelablePromise<Wealthlane_AwardService_Dtos_IsoCalculationValues_IsoCalculationValuesDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/iso-calculation-values/iso-calculation-values',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_IsoCalculationValues_IsoCalculationValuesDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppIsoCalculationValuesIsoCalculationSortingTypes(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_IsoCalculationValues_IsoCalculationValuesDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/iso-calculation-values/iso-calculation-sorting-types',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_IsoCalculationValues_IsoCalculationValuesDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppIsoCalculationValuesOrUpdateIsoCalculationValues(
requestBody?: Wealthlane_AwardService_Dtos_IsoCalculationValues_CreateUpdateIsoCalculationValuesDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_IsoCalculationValues_IsoCalculationValuesDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/iso-calculation-values/or-update-iso-calculation-values',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
